import Graphic from "@arcgis/core/Graphic";
import proj4 from "proj4";

// @ts-ignore
import flagUrl from "./flag.png";

export const updateVertices = async (
  e: any,
  type: string,
  view: __esri.MapView | null,
  setCurrentGraphic: (graphic: __esri.Graphic) => void
) => {
  const vertices = e.vertices;
  if (!view) return;
  view.graphics.removeAll();
  if (type === "polygon") {
    if (vertices.length > 2) {
      const graphic = getPolygonGraphic(vertices, view.spatialReference);
      setCurrentGraphic(graphic);
    } else {
      const graphic = getPolylineGraphic(vertices, view.spatialReference);
      setCurrentGraphic(graphic);
    }
  } else if (type === "polyline") {
    const graphic = getPolylineGraphic(vertices, view.spatialReference);
    setCurrentGraphic(graphic);
  } else if (type === "point") {
    const graphic = getPointGraphic(vertices[0], view.spatialReference);
    setCurrentGraphic(graphic);
  }
};

const getPolylineGraphic = (vertices: any, sr: __esri.SpatialReference) => {
  const graphic = new Graphic({
    geometry: {
      type: "polyline",
      paths: vertices,
      spatialReference: sr,
    },
    symbol: {
      type: "simple-line",
      color: [4, 90, 141],
      width: 4,
      cap: "round",
      join: "round",
    },
  });
  return graphic;
};

const getPolygonGraphic = (vertices: any, sr: __esri.SpatialReference) => {
  console.log(vertices);
  return new Graphic({
    geometry: {
      type: "polygon",
      rings: [vertices],
      spatialReference: sr,
    },
    symbol: {
      type: "simple-fill",
      color: [0, 0, 0, 0],
      outline: {
        color: [4, 90, 141],
        width: 4,
      },
    },
  });
};

export const getTextGraphic = (startVertex, endVertex, distanceLabel, sr) => {
  const [startX, startY] = startVertex;
  const [endX, endY] = endVertex;

  const angleRadians = Math.atan2(endY - startY, endX - startX);
  let angleDegrees = angleRadians * (180 / Math.PI);
  let angle = 360 - ((angleDegrees + 360) % 360);
  const [centerX, centerY] = [(startX + endX) / 2, (startY + endY) / 2];

  const xoffset = angle > 90 && angle < 270 ? -8 : 8;
  const yoffset = angle > 90 && angle < 270 ? -8 : 8;
  // const yoffset = 8;

  // Fix angle
  if (angle > 90 && angle < 270) {
    angle = angle + 180;
  }

  const textGraphic = new Graphic({
    geometry: {
      type: "point",
      x: centerX,
      y: centerY,
      spatialReference: sr,
    },
    symbol: {
      type: "text",
      color: "black",
      haloColor: "white",
      haloSize: 1,
      xoffset,
      yoffset,
      angle: Math.abs(angle),
      font: {
        size: 10,
        family: "sans-serif",
      },
      text: distanceLabel,
    },
  });
  return textGraphic;
};

const getPointGraphic = (point: any, sr: __esri.SpatialReference) => {
  return new Graphic({
    geometry: {
      type: "point",
      x: point[0],
      y: point[1],
      spatialReference: sr,
    },
    symbol: {
      type: "picture-marker",
      url: flagUrl,
      xoffset: 4,
      yoffset: 5,
      size: 8,
    },
  });
};

export const projectToDecimalDegrees = (x: number, y: number) => {
  const firstProjection =
    'PROJCS["NAD83 / Illinois East (ftUS)",GEOGCS["NAD83",DATUM["North_American_Datum_1983",SPHEROID["GRS 1980",6378137,298.257222101],TOWGS84[0,0,0,0,0,0,0]],PRIMEM["Greenwich",0,AUTHORITY["EPSG","8901"]],UNIT["degree",0.0174532925199433,AUTHORITY["EPSG","9122"]],AUTHORITY["EPSG","4269"]],PROJECTION["Transverse_Mercator"],PARAMETER["latitude_of_origin",36.6666666666667],PARAMETER["central_meridian",-88.3333333333333],PARAMETER["scale_factor",0.999975],PARAMETER["false_easting",984250],PARAMETER["false_northing",0],UNIT["US survey foot",0.304800609601219],AXIS["Easting",EAST],AXIS["Northing",NORTH],AUTHORITY["EPSG","3435"]]';

  return proj4(firstProjection, "WGS84", [x, y]);
};
